import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ProductCard from "../pages/ProductCard";
import { getErrorMessage } from "../api/client";
import { useCart } from "../context/CartContext";
import { getDefaultCartExtras } from "../utils/variants";
import { HOME_FALLBACKS } from "../constants/homeDefaults";
import "./FeaturedProductsSection.css";

const FeaturedProductsSection = ({ data }) => {
  const { addToCart } = useCart();
  const [pending, setPending] = useState(false);
  const products = data?.products || [];
  const defaults = HOME_FALLBACKS.featuredProducts;

  const subtitle = data?.subtitle || defaults.subtitle;
  const title = data?.title || defaults.title;
  const description = data?.description || defaults.description;
  const buttonText = data?.buttonText || defaults.buttonText;
  const buttonLink = data?.buttonLink || defaults.buttonLink;

  if (!products.length) return null;

  const handleAddToCart = async (product) => {
    if (pending) return;
    setPending(true);
    try {
      const extras = getDefaultCartExtras(product);
      await addToCart(product.id, 1, extras);
      toast.success("Added to cart");
    } catch (error) {
      toast.error(getErrorMessage(error, "Could not add to cart"));
    } finally {
      setPending(false);
    }
  };

  return (
    <section className="featured-products-section" id="featured-products">
      <div className="featured-products-header">
        <span className="featured-products-subtitle">{subtitle}</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>

      <div className="featured-products-grid">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onAddToCart={handleAddToCart}
          />
        ))}
      </div>

      <div className="featured-products-cta">
        <Link to={buttonLink} className="featured-products-btn">
          {buttonText}
        </Link>
      </div>
    </section>
  );
};

export default FeaturedProductsSection;
